/**
 * French legal copy — approved translation (tu informal).
 * Source: /app/drafts/legal_translations/fr.md with Laura's refinement:
 *   - Use standard "..." quotes (not «...» guillemets) for web consistency.
 */

const fr = {
    terms: {
        preamble: [
            { type: "para", text: 'Other Side est une plateforme numérique exploitée par Laura Stella, opérant sous le nom "Other Side".' },
        ],
        sections: [
            { number: 1, title: "Nature du service", blocks: [
                { type: "para", text: "Other Side utilise des technologies d'intelligence artificielle pour générer des expériences simulées basées sur les contenus que tu fournis." },
                { type: "para", text: "Les interactions générées ne représentent pas des communications réelles et n'impliquent ni la présence ni la conscience de la personne représentée." },
            ]},
            { number: 2, title: "Conditions d'utilisation", blocks: [
                { type: "para", text: "Tu dois avoir au moins 18 ans et utiliser le service dans le respect des lois applicables." },
            ]},
            { number: 3, title: "Responsabilité des contenus", blocks: [
                { type: "para", text: "Tu es responsable des contenus que tu télécharges et tu déclares avoir le droit de les utiliser." },
            ]},
            { number: 4, title: "Personnes représentées", blocks: [
                { type: "para", text: "Tu garantis ne pas violer les droits de tiers, y compris les droits relatifs aux personnes décédées." },
            ]},
            { number: 5, title: "Usage interdit", blocks: [
                { type: "para", text: "L'utilisation du service à des fins illégales, frauduleuses ou portant atteinte aux droits d'autrui est interdite." },
            ]},
            { number: 6, title: "Limitation de responsabilité", blocks: [
                { type: "para", text: "Other Side n'est pas responsable des interprétations subjectives, des réactions émotionnelles ou de l'usage inapproprié du service." },
            ]},
            { number: 7, title: "Interruption", blocks: [
                { type: "para", text: "Le service peut être suspendu ou limité en cas de violations." },
            ]},
            { number: 8, title: "Tes droits", blocks: [
                { type: "para", text: "Tu peux demander l'accès, la modification ou la suppression de tes données." },
            ]},
            { number: 9, title: "Modifications", blocks: [
                { type: "para", text: "Les présentes conditions peuvent être mises à jour à tout moment." },
            ]},
            { number: 10, title: "Loi applicable", blocks: [
                { type: "para", text: "Le service est régi par la réglementation européenne applicable." },
            ]},
        ],
    },

    privacy: {
        preamble: [
            { type: "contact", label: "Responsable du traitement", value: 'Laura Stella, opérant sous le nom "Other Side"' },
            { type: "contact", label: "Email", value: "os.otherside.app@gmail.com", mailto: true },
        ],
        sections: [
            { number: 1, title: "Types de données collectées", blocks: [
                { type: "list", items: [
                    "Données identifiantes",
                    "Contenus téléchargés (images, audio, vidéo)",
                    "Données biométriques (voix, images)",
                    "Données techniques (IP, appareil, logs)",
                ]},
            ]},
            { number: 2, title: "Finalités", blocks: [
                { type: "list", items: [
                    "Fourniture du service",
                    "Génération de contenus IA",
                    "Sécurité et amélioration",
                ]},
            ]},
            { number: 3, title: "Base juridique", blocks: [
                { type: "list", items: [
                    "Consentement explicite",
                    "Exécution du service",
                ]},
            ]},
            { number: 4, title: "Données biométriques", blocks: [
                { type: "para", text: "Les données biométriques ne sont traitées qu'avec ton consentement explicite." },
            ]},
            { number: 5, title: "Conservation", blocks: [
                { type: "para", text: "Les données sont conservées le temps nécessaire au service." },
            ]},
            { number: 6, title: "Tes droits", blocks: [
                { type: "para", text: "Accès, rectification, suppression, limitation, opposition." },
            ]},
            { number: 7, title: "Transferts", blocks: [
                { type: "para", text: "Les données peuvent être traitées sur des serveurs situés dans l'Union européenne ou en dehors, dans le respect des réglementations applicables." },
            ]},
            { number: 8, title: "Sécurité", blocks: [
                { type: "para", text: "Des mesures techniques et organisationnelles sont mises en place pour protéger les données." },
            ]},
            { number: 9, title: "Réclamations", blocks: [
                { type: "para", text: "Tu peux contacter l'autorité de contrôle compétente." },
            ]},
        ],
    },

    biometric: {
        preamble: [
            { type: "para", text: "Tu donnes ton consentement explicite au traitement de :" },
        ],
        sections: [
            { title: "Données biométriques concernées", blocks: [
                { type: "list", items: ["images", "voix", "contenus audio et vidéo"] },
                { type: "para", text: "aux fins de la création de l'expérience numérique." },
            ]},
            { title: "Nature du consentement", blocks: [
                { type: "para", text: "Le consentement est :" },
                { type: "list", items: ["libre", "éclairé", "révocable"] },
            ]},
            { title: "Révocation", blocks: [
                { type: "para", text: "Tu peux le révoquer à tout moment via les paramètres de ton compte ou sur demande directe." },
            ]},
        ],
    },

    ai_notice: {
        preamble: [
            { type: "para", text: "Other Side utilise des systèmes d'intelligence artificielle." },
        ],
        sections: [
            { title: "Les interactions", blocks: [
                { type: "list", items: [
                    "sont générées artificiellement",
                    "peuvent simuler voix, style et contenus",
                    "ne représentent pas des communications réelles",
                ]},
            ]},
            { title: "Limites du système", blocks: [
                { type: "para", text: "Le service ne recrée ni conscience ni identité réelle." },
                { type: "para", text: "Tu acceptes d'interagir avec un système d'IA et en comprends les limites." },
            ]},
        ],
    },

    memorial: {
        preamble: [
            { type: "para", text: "Other Side permet la création d'expériences basées sur des contenus relatifs à des personnes." },
        ],
        sections: [
            { number: 1, title: "Responsabilité", blocks: [
                { type: "para", text: "Tu es responsable des contenus que tu télécharges." },
            ]},
            { number: 2, title: "Personnes décédées", blocks: [
                { type: "para", text: "Tu déclares avoir le droit ou l'autorisation d'utiliser les contenus." },
            ]},
            { number: 3, title: "Droits des proches", blocks: [
                { type: "para", text: "Les demandes de suppression ou de modification peuvent être faites par les personnes légitimes." },
            ]},
            { number: 4, title: "Signalements", blocks: [
                { type: "para", text: "Other Side se réserve le droit de retirer les contenus contestés." },
            ]},
            { number: 5, title: "Limitations", blocks: [
                { type: "para", text: "Le service ne garantit ni exactitude historique ni représentation réelle." },
            ]},
        ],
    },
};

export default fr;
